/**
 * Conde · Accordion Toggle
 * ------------------------
 * Global click + toggle handling for every .hv2-accordion__item on the site.
 *
 * Previously duplicated inline in 5 liquid files (conde-by-stylists,
 * conde-accessory-accordion, conde-education-certification,
 * conde-product-accordion, conde-pdp-accordion). Consolidated here and
 * loaded once from layout/theme.liquid.
 *
 * Uses event delegation on `document`, so DOM readiness at load time is
 * irrelevant. New accordion instances (e.g. theme-editor section reloads)
 * inherit the same listeners with no reinitialisation.
 */
(function () {
  if (window.__condeAccordionInit) return;
  window.__condeAccordionInit = true;

  function closeItem(item) {
    if (!item.classList.contains('is-open')) return;
    item.classList.remove('is-open');
    var trig = item.querySelector(':scope > .hv2-accordion__trigger');
    if (trig) trig.setAttribute('aria-expanded', 'false');
  }

  // Button-triggered accordions: close siblings within the same .hv2-accordion group.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.hv2-accordion__trigger');
    if (!trigger) return;
    if (trigger.tagName === 'SUMMARY') return; // native <details> handled below
    var item = trigger.closest('.hv2-accordion__item');
    if (!item) return;
    var group = item.parentElement;
    var willOpen = !item.classList.contains('is-open');
    if (willOpen && group) {
      group.querySelectorAll(':scope > .hv2-accordion__item.is-open').forEach(function (sib) {
        if (sib !== item) closeItem(sib);
      });
    }
    item.classList.toggle('is-open', willOpen);
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });

  // Native <details class="hv2-accordion__item">: close siblings on toggle-open.
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!(item instanceof HTMLDetailsElement)) return;
    if (!item.classList.contains('hv2-accordion__item')) return;
    if (!item.open) return;
    var group = item.parentElement;
    if (!group) return;
    group.querySelectorAll(':scope > details.hv2-accordion__item[open]').forEach(function (sib) {
      if (sib !== item) sib.open = false;
    });
  }, true);
})();
